/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgInsuranceId32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='#231F20'
        fillRule='evenodd'
        d='M13.136 9.996a2.848 2.848 0 012.85-2.846 2.848 2.848 0 012.85 2.846 2.848 2.848 0 01-2.85 2.845 2.848 2.848 0 01-2.85-2.845zm2.85-1.346c-.747 0-1.35.604-1.35 1.346 0 .741.603 1.345 1.35 1.345.747 0 1.35-.604 1.35-1.345 0-.742-.603-1.346-1.35-1.346z'
      />
      <path
        fill='#231F20'
        fillRule='evenodd'
        d='M10.928 17.833a7.71 7.71 0 01-2.678-5.849c0-4.273 3.471-7.734 7.75-7.734s7.75 3.461 7.75 7.734a7.71 7.71 0 01-2.68 5.85l.012.032-.43.325a7.718 7.718 0 01-9.304 0l-.43-.325.01-.033zM9.75 11.984c0-3.441 2.797-6.234 6.25-6.234s6.25 2.793 6.25 6.234c0 1.655-.647 3.16-1.703 4.277l-.235-.707a2.146 2.146 0 00-2.05-1.505h-4.515a2.153 2.153 0 00-2.042 1.469l.711.238-.712-.237-.25.744a6.205 6.205 0 01-1.704-4.279zm10.562 3.57l.002.008-.716.222.712-.237.002.007zm-1.008 1.723a6.232 6.232 0 01-3.304.941 6.232 6.232 0 01-3.303-.94l.43-1.284v-.002a.647.647 0 01.618-.443h4.516a.652.652 0 01.62.456l.003.008.42 1.264z'
      />
      <path
        fill='#231F20'
        d='M8.25 22.75a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM22.794 22h-9.642v1.5h9.643V22zM8.25 26.75a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM22.794 26h-9.642v1.5h9.643V26z'
      />
      <path
        fill='#231F20'
        fillRule='evenodd'
        d='M5 4a3 3 0 013-3h16a3 3 0 013 3v24a3 3 0 01-3 3H8a3 3 0 01-3-3V4zm3-1.5h16A1.5 1.5 0 0125.5 4v24a1.5 1.5 0 01-1.5 1.5H8A1.5 1.5 0 016.5 28V4A1.5 1.5 0 018 2.5z'
      />
    </svg>
  );
}

export default SvgInsuranceId32;
